// В.1.f-2-A: добавление PERMANENT keyword'а юниту до конца матча.
//
// Используется Учебной частью (Глобал, Действие): каждому своему юниту
// случайный keyword из {taunt, stealth, pierce, frenzy} навсегда.
//
// Хранение:
//   - Keyword пушится в card.persistentKeywords (массив строк) — это
//     существующая «постоянная» категория (Кустарный стимулятор, и т.п.).
//     Снимается ТОЛЬКО Молчанием (silence.js обнуляет persistentKeywords)
//     или возвратом в руку через Офицера связи (resetCardToTemplate).
//   - Также пушится в card.keywords (current effective list), если ещё нет.
//
// Семантика «несколько источников одного keyword'а»: реализована через
// дедупликацию в persistentKeywords. По текущему дизайну единственный
// путь снятия Permanent keyword'а — Молчание/возврат в руку, оба
// чистят persistentKeywords целиком, поэтому подсчёт source'ов
// избыточен. Аргумент sourceLabel используется только для лога.

import { hasKeyword } from '../keywords.js';

export function addPermanentKeyword(state, card, kw, sourceId = 'unknown', sourceLabel = '') {
  if (!card || !kw) return false;
  if (!Array.isArray(card.persistentKeywords)) card.persistentKeywords = [];
  if (!Array.isArray(card.keywords)) card.keywords = [];

  // Стелс-блок: если на цели stealthSuppressed (Нетраннер-адъютант снёс
  // Скрытность навсегда) — попытка дать stealth не должна срабатывать.
  if (kw === 'stealth' && (card.stealthUsed || card.stealthSuppressed)) {
    if (state?.log && sourceLabel) {
      const ownerName = state.players?.[card.ownerId]?.name || '?';
      state.log.add(
        `${sourceLabel} → ${card.name_ru} [${ownerName}]: Скрытность подавлена, ` +
        `keyword не выдан`
      );
    }
    return false;
  }

  if (!card.persistentKeywords.includes(kw)) card.persistentKeywords.push(kw);
  if (!hasKeyword(card, kw)) card.keywords.push(kw);

  if (state?.log && sourceLabel) {
    const ownerName = state.players?.[card.ownerId]?.name || '?';
    state.log.add(`📚 ${sourceLabel} → ${card.name_ru} [${ownerName}]: получает «${kw}» (постоянно)`);
  }
  return true;
}
